import { useQuery } from 'react-query'
import { getMoneyPoolManagement } from 'services/fund'

export default function useGetMoneyPoolManagement(id: string | undefined) {
    const { data, isLoading, refetch } = useQuery(
        ['moneyPool-management', id],
        getMoneyPoolManagement
    )
    return {
        moneyPoolManagement: data,
        isLoadingMoneypoolManagement: isLoading,
        refetch,
    }
}
